import React, { useState, useEffect, useRef, Component } from 'react';
import Picker from 'react-month-picker';
// import Tappable from 'common/components/GlobalMonthPicker/MonthRangePicker/react-tapper';
import PropTypes from 'prop-types';
import './month-picker.css';

class MonthBox extends Component {
  static propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.value || 'N/A'
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {
      value: props.value || 'N/A'
    };
  }

  render() {
    return (
      <div className="box w-full " onClick={this._handleClick}>
        <label className="text-center mx-auto block">
          {this.props.placeHolder ? this.props.placeHolder : this.state.value}
        </label>
      </div>
    );
  }

  _handleClick = e => {
    this.props.onClick && this.props.onClick(e);
  };
}

const MonthRangePicker = ({
  autoRange,
  maxMonth,
  singlePicker,
  rangeValue,
  setRangeValue,
  validRange,
  setValidRange,
  multiValue,
  setMultiValue,
  onChangeSinglePicker,
  placeHolder
}) => {
  const pickAMonth = useRef(null);
  const pickMulti = useRef(null);
  const pickRange2 = useRef(null);

  const pickerLang = {
    months: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    from: 'From',
    to: 'To'
  };

  const makeText = m => {
    if (m && m.year && m.month)
      return pickerLang.months[m.month - 1] + '. ' + m.year;
    return '?';
  };

  //for choosing an span of month
  const handleRangeChange = (year, month, ref) => {
    let updatedYear, updatedMonth;
    if (singlePicker) {
      setRangeValue({ year: year, month: month });
      if (typeof onChangeSinglePicker == 'function') {
        onChangeSinglePicker({ year: year, month: month });
      }
      pickAMonth.current._onDismiss();
      return;
    }
    if (ref === 0 && autoRange)
      if (month + autoRange > 12) {
        updatedYear = year + 1;
        updatedMonth = ((month + autoRange) % 12) - 1;
      } else {
        updatedYear = year;
        updatedMonth = month + autoRange - 1;
      }
    else if (ref === 1 && autoRange)
      if (month - autoRange < 0) {
        updatedYear = year - 1;
        updatedMonth = ((month - autoRange) % 12) + 13;
      } else {
        updatedYear = year;
        updatedMonth = month - autoRange + 1;
      }

    if (ref === 0) {
      if (autoRange) {
        setRangeValue({
          from: { year: year, month: month },
          to: { year: updatedYear, month: updatedMonth }
        });
      } else
        setRangeValue({ ...rangeValue, from: { year: year, month: month } });
    }
    if (ref === 1) {
      if (autoRange) {
        setRangeValue({
          from: { year: updatedYear, month: updatedMonth },
          to: { year: year, month: month }
        });
      } else {
        setRangeValue({ ...rangeValue, to: { year: year, month: month } });
      }
    }
  };

  const handleRangeDissmis = () => {};

  const _handleClickMonthBox = e => {
    pickAMonth.current.show();
  };

  // for multiMonth
  const handleClickMultiBox = e => {
    pickMulti.current.show();
  };
  const handleMultiChange = (year, month, index) => {
    let temp2;
    let temp = multiValue;
    let v = { year: year, month: month };
    let test = temp.findIndex(t => JSON.stringify(t) === JSON.stringify(v));
    //if maxMonth is set
    if (maxMonth)
      if (multiValue.length < maxMonth) {
        if (test === -1) {
          temp2 = [...temp, { year: year, month: month }];
          return setMultiValue(temp2);
        } else if (test !== -1) {
          temp.splice(test, 1);
          return setMultiValue(temp);
        }
      } else {
        if (test !== -1) {
          temp.splice(test, 1);
          return setMultiValue(temp);
        }
      }
    else {
      if (test === -1) {
        temp2 = [...temp, { year: year, month: month }];
        return setMultiValue(temp2);
      } else if (test !== -1) {
        temp.splice(test, 1);
        return setMultiValue(temp);
      }
    }
  };
  //
  const handleRangeChange2 = (value, text, listIndex, a, b, c) => {
    //
  };
  const _handleClickRangeBox2 = e => {
    pickRange2.current.show();
  };

  return (
    <>
      <div className="edit w-full mr-auto text-left self-center z-10">
        <Picker
          ref={multiValue ? pickMulti : pickAMonth}
          years={validRange} //{ min: 2013 }
          value={multiValue ? multiValue : rangeValue}
          lang={pickerLang}
          theme="light"
          onChange={multiValue ? handleMultiChange : handleRangeChange}
          onDismiss={handleRangeDissmis}
        >
          {singlePicker ? (
            <MonthBox
              value={makeText(rangeValue)}
              onClick={_handleClickMonthBox}
              placeHolder={placeHolder}
            />
          ) : multiValue ? (
            <MonthBox
              value={multiValue.map(v => makeText(v)).join(' | ')}
              onClick={handleClickMultiBox}
              placeHolder={placeHolder}
            />
          ) : (
            <MonthBox
              value={
                makeText(rangeValue.from) + ' ~ ' + makeText(rangeValue.to)
              }
              onClick={_handleClickMonthBox}
              placeHolder={placeHolder}
            />
          )}
        </Picker>
      </div>
    </>
  );
};

export default MonthRangePicker;
